import React from 'react';
import LoginHeader from "./LoginHeader"

class LoginLayout extends React.Component {
  render () {
    return (
      <div className='d-flex flex-column login'>
        <LoginHeader />

        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <main>
                {this.props.children}
              </main>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default LoginLayout;
